<template>
  <div class="animated fadeIn profile-component">
    <vLoading v-if="vLoading" />
    <div v-if="$router.currentRoute.path == '/company/dashboard' && loaded">
      <v-row>
        <v-col>
          <v-card class="common-card mt-1 mb-1">
            <p class="c-dark red--text text--lighten-1 mb-0">
              <v-icon class="red--text">mdi-alert</v-icon> شرکت محترم، لطفا در
              وارد کردن اطلاعات زیر نهایت دقت و توجه را داشته باشید. ستاد توسعه
              زیست فناوری در صورت مشاهده هرگونه مغایرت مجاز به حذف اطلاعات و
              محدود کردن دسترسی شما خواهد بود.
            </p>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="6" xl="6" class="pb-0">
          <v-card class="transparent-card card-height">
            <v-row class="h-100 mb-2">
              <v-col sm="6" cols="12" class="pb-0">
                <v-card class="common-card card-height">
                  <v-row>
                    <v-col>
                      <div class="d-flex flex-row">
                        <h5 class="mt-1 mb-4 c-dark fs-xxlarge">نام شرکت</h5>
                        <span @click="openNoEditDialog('name')">
                          <v-icon
                            class="c-purple pb-1 px-2 pointer"
                            style="font-size: 1.7rem"
                            >mdi-alert-circle-outline</v-icon
                          >
                        </span>
                      </div>
                      <div class="c-grey fs-xlarge mb-16">
                        {{ companyInfo.name }}
                      </div>
                    </v-col>
                  </v-row>
                  <div
                    @click="
                      editMoreInfo = false;
                      update();
                      moreInfoDialog = true;
                      editInfo = JSON.parse(JSON.stringify(companyInfo));
                    "
                    class="company-id pointer text-left"
                  >
                    <div class="btn-border bc-white ps-4 pe-4 py-2">
                      <span class="c-purple fs-small"
                        >مشاهده شناسنامه شرکت
                      </span>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col sm="6" cols="12" class="pb-0"
                ><v-card class="common-card card-height">
                  <v-row>
                    <v-col>
                      <h5 class="mt-1 mb-3 c-dark fs-xxlarge">لوگو شرکت</h5>
                    </v-col>
                    <v-col cols="2" class="text-left">
                      <span @click="openEditModal('logo')" class="pointer">
                        <v-icon>$Edit</v-icon>
                      </span>
                    </v-col>
                  </v-row>
                  <div
                    @click="showBigModal = true"
                    class="logo-box pointer mt-13"
                  >
                    <img
                      :src="
                        companyInfo.avatar
                          ? companyInfo.avatar
                          : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                      "
                    />
                  </div> </v-card
              ></v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6" xl="6">
          <v-card class="common-card">
            <v-row class="mb-1">
              <v-col>
                <h5 class="mt-1 c-dark fs-xxlarge">اطلاعات تماس شرکت</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="openEditModal('contact')" class="pointer"
                  ><v-icon>$Edit</v-icon></span
                >
              </v-col>
            </v-row>
            <div class="c-grey">
              <v-icon class="pe-2 ps-0">$Location</v-icon>
              <span class="fs-medium">
                نشانی شرکت:
                {{
                  companyInfo.state +
                  ", " +
                  companyInfo.city +
                  (companyInfo.city ? ", " : "")
                }}
                {{ companyInfo.address ? companyInfo.address : "--" }}
              </span>
            </div>
            <div class="pt-4 c-grey">
              <v-icon class="pe-2 ps-0">$Phone</v-icon>
              <span class="fs-medium">
                تلفن‌های تماس:
                <span dir="ltr">{{
                  companyInfo.tel ? companyInfo.tel : "--"
                }}</span>
              </span>
            </div>
            <div class="pt-4 c-grey">
              <v-icon class="pe-2 ps-0">$Email</v-icon>
              <span class="fs-medium">
                ایمیل:
                {{ companyInfo.email ? companyInfo.email : "--" }}
              </span>
            </div>
            <div class="pt-4 c-grey">
              <v-icon class="pe-2 ps-0">$Url</v-icon>
              <span class="fs-medium" v-if="companyInfo.website">
                آدرس‌‌ تارنما:
                <a :href="checkWebsite()" target="_blank">{{
                  companyInfo.website
                }}</a>
              </span>
              <span class="fs-medium" v-else> آدرس‌‌ تارنما: -- </span>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="6" xl="6">
          <v-card class="common-card card-height">
            <v-row class="mb-4">
              <v-col>
                <h5 class="mt-1 c-dark fs-xxlarge">توضیحات</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="openEditModal('description')" class="pointer"
                  ><v-icon>$Edit</v-icon></span
                >
              </v-col>
            </v-row>
            <div v-if="companyInfo.description">
              <div v-if="type != 'mobile'">
                <p class="c-grey fs-medium mb-0">
                  {{
                    companyInfo.description.length > 350
                      ? companyInfo.description.slice(0, 350) + "..."
                      : companyInfo.description
                  }}
                </p>
                <div
                  v-if="companyInfo.description.length > 350"
                  class="text-left pt-5"
                >
                  <v-btn
                    class="seeMore-btn"
                    @click="openSeeMoreModal('description')"
                    text
                  >
                    <span class="c-primary">مشاهده بیشتر</span>
                  </v-btn>
                </div>
              </div>
              <div v-if="type == 'mobile'">
                <p class="c-grey fs-medium mb-0">
                  {{
                    companyInfo.description.length > 200
                      ? companyInfo.description.slice(0, 200) + "..."
                      : companyInfo.description
                  }}
                </p>
                <div
                  v-if="companyInfo.description.length > 200"
                  class="text-left pt-5"
                >
                  <v-btn
                    class="seeMore-btn"
                    @click="openSeeMoreModal('description')"
                    text
                  >
                    <span class="c-primary">مشاهده بیشتر</span>
                  </v-btn>
                </div>
              </div>
            </div>
            <div v-else>
              <hr />
              <p class="c-grey fs-small text-center">
                توضیحی برای شرکت ثبت نشده است.
              </p>
              <hr />
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6" xl="6">
          <v-card class="common-card card-height">
            <v-row class="mb-1">
              <v-col class="d-flex flex-row">
                <h5 class="mb-4 fs-xxlarge">محصولات</h5>
                <h6 class="px-2 fs-large">
                  {{
                    companyInfo.products.length
                      ? "( " + companyInfo.products.length + "مورد )"
                      : ""
                  }}
                </h6>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="openEditModal('products')" class="pointer">
                  <v-icon>$Edit</v-icon>
                </span>
              </v-col>
            </v-row>
            <div v-if="companyInfo.products">
              <div v-if="companyInfo.products.length" class="ms-5">
                <div v-if="companyInfo.products.length > 3">
                  <div
                    v-for="(product, index) in companyInfo.products.slice(0, 3)"
                    :key="index"
                    class="mb-3"
                  >
                    <li class="fs-medium c-grey">
                      {{
                        product.title.length > 70
                          ? product.title.slice(0, 70) + "..."
                          : product.title
                      }}
                    </li>
                  </div>
                  <div class="text-left pt-3">
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('products')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
                <div v-else>
                  <div
                    v-for="(product, index) in companyInfo.products"
                    :key="index"
                    class="mb-3"
                  >
                    <li class="fs-medium c-grey">
                      {{
                        product.title.length > 70
                          ? product.title.slice(0, 70) + "..."
                          : product.title
                      }}
                    </li>
                  </div>
                  <div v-if="showProductMoreBtn" class="text-left pt-3">
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('products')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div v-else class="my-4 c-grey fs-small text-center">
                <hr />
                محصولی به ثبت نرسیده است.
                <hr />
              </div>
            </div>
            <div v-else>
              <hr />
              <p class="c-grey fs-small text-center">
                محصولی برای شرکت ثبت نشده است.
              </p>
              <hr />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="6" md="12" cols="12">
          <v-card class="common-card w-100 card-height">
            <v-card-title class="px-0">
              <v-row class="mb-2">
                <v-col class="pt-0">
                  <h5 class="fs-xxlarge">گالری تصاویر</h5>
                </v-col>
                <v-col cols="3" class="pt-0 text-left">
                  <v-icon
                    @click="goToImages()"
                    style="transform: translateY(-4px)"
                    >$Edit</v-icon
                  >
                </v-col>
              </v-row>
            </v-card-title>
            <div
              v-if="!companyInfo.gallery || !companyInfo.gallery.length"
              class="pb-4 c-grey fs-small text-center"
            >
              <hr />
              تصویری برای این شرکت به ثبت نرسیده است.
              <hr />
            </div>
            <div v-else>
              <v-row v-if="type != 'mobile'">
                <v-col
                  class="text-center img-col d-flex"
                  cols="4"
                  v-for="(img, index) in companyInfo.gallery.slice(0, 3)"
                  :key="index"
                >
                  <img :src="img.url" class="company-img mb-2" />
                  <span class="fs-medium">{{
                    img.title.length > 20
                      ? img.title.slice(0, 20) + "..."
                      : img.title
                  }}</span>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-carousel
                  :show-arrows="companyInfo.gallery.length > 1"
                  v-model="model"
                  hide-delimiters
                >
                  <v-carousel-item
                    cycle
                    v-for="(img, index) in companyInfo.gallery"
                    :key="index"
                    :src="img.url"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                    class="slider"
                  >
                  </v-carousel-item>
                </v-carousel>
              </v-row>
            </div>
          </v-card>
        </v-col>
        <v-col lg="6" md="12" cols="12" class="stretch-col">
          <v-card class="common-card card-height">
            <v-row class="mb-1">
              <v-col class="d-flex flex-row">
                <h5 class="mb-4 fs-xxlarge">موضوع فعالیت زیست فناوری</h5>
                <span @click="openNoEditDialog('category')">
                  <v-icon
                    class="c-purple pb-1 px-2 pointer"
                    style="font-size: 1.7rem; transform: translateY(-2px)"
                    >mdi-alert-circle-outline</v-icon
                  >
                </span>
              </v-col>
            </v-row>
            <div
              v-if="companyInfo.catName != ''"
              class="py-4 c-grey fs-small ms-5"
            >
              <div class="mb-3">
                <li class="fs-medium">
                  {{ companyInfo.catName }}
                </li>
              </div>
              <div v-if="showCategoryMoreBtn" class="text-left pt-3">
                <v-btn
                  class="seeMore-btn"
                  @click="openSeeMoreModal('category')"
                  text
                >
                  <span class="c-primary">مشاهده بیشتر</span>
                </v-btn>
              </div>
            </div>
            <div v-else class="my-8 c-grey fs-small text-center">
              <hr />
              موضوعی به ثبت نرسیده است.
              <hr />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="moreInfoDialog" width="600">
        <v-card class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xxlarge">شناسنامه شرکت</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span
                  @click="
                    moreInfoDialog = false;
                    editMoreInfo = false;
                  "
                >
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div class="textField-box" v-if="editMoreInfo">
              <v-text-field
                label="مدیر عامل"
                outlined
                rounded
                :loading="gettingInfo"
                v-model="editInfo.ceoName"
              ></v-text-field>
              <v-text-field
                label="کد ثبت"
                outlined
                rounded
                type="number"
                :loading="gettingInfo"
                v-model="editInfo.registrationNumber"
              >
                <template v-slot:label>
                  <div class="d-flex flex-row c-purple">
                    <span class="red--text pe-1">*</span> کد ثبت
                  </div>
                </template></v-text-field
              >
              <v-text-field
                label="شناسه‌ملی"
                outlined
                rounded
                type="number"
                :loading="gettingInfo"
                v-model="editInfo.nationalId"
              >
                <template v-slot:label>
                  <div class="d-flex flex-row c-purple">
                    <span class="red--text pe-1">*</span> شناسه ملی
                  </div>
                </template></v-text-field
              >
              <v-text-field
                label="کد اقتصادی"
                outlined
                rounded
                type="number"
                :loading="gettingInfo"
                v-model="editInfo.economicCode"
              ></v-text-field>

              <div class="mt-3">
                <v-btn
                  elevation="0"
                  class="btn-border bc-white c-purple me-4"
                  width="100"
                  height="42"
                  @click="editMoreInfo = false"
                >
                  لغو
                </v-btn>
                <v-btn
                  @click="openConfirmationDialog('registrationInfo')"
                  color="#93329e"
                  class="c-light"
                  width="100"
                  height="42"
                  elevation="0"
                  :disabled="
                    !editInfo.nationalId || !editInfo.registrationNumber
                  "
                  >تایید</v-btn
                >
              </div>
            </div>
            <div class="textField-box" v-else>
              <p class="c-grey fs-medium">
                <v-icon class="pe-2 pt-1" color="purple"
                  >mdi-account-outline</v-icon
                >
                مدیر عامل:
                {{ companyInfo.ceoName ? companyInfo.ceoName : "--" }}
              </p>
              <p class="c-grey fs-medium">
                <v-icon class="pe-2 pt-1" color="purple">mdi-domain</v-icon>
                کد ثبت:
                {{
                  companyInfo.registrationNumber
                    ? companyInfo.registrationNumber
                    : "--"
                }}
              </p>
              <p class="c-grey fs-medium">
                <v-icon class="pe-2 pt-1" color="purple"
                  >mdi-card-bulleted-outline</v-icon
                >
                شناسه ملی:

                {{ companyInfo.nationalId ? companyInfo.nationalId : "--" }}
              </p>
              <p class="c-grey fs-medium mb-0">
                <v-icon class="pe-2 pt-1" color="purple">mdi-counter</v-icon>
                کد اقتصادی:

                {{ companyInfo.economicCode ? companyInfo.economicCode : "--" }}
              </p>

              <v-row class="pt-5 pb-2 px-3 edit-row">
                <v-btn
                  @click="editMoreInfo = true"
                  v-if="!editMoreInfo"
                  class="purple-btn"
                  height="40"
                  elevation="0"
                >
                  <v-icon class="pe-2 pt-2">$Edit</v-icon>
                  ویرایش
                </v-btn>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="seeMoreModal" width="600">
        <v-card v-if="seeMoreType == 'description'" class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xxlarge">{{ companyInfo.name }}</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="seeMoreModal = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>

            <p class="c-grey fs-medium" style="line-height: 30px">
              {{ companyInfo.description }}
            </p>
          </v-container>
        </v-card>
        <v-card v-if="seeMoreType == 'products'" class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xxlarge">محصولات</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="seeMoreModal = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>

            <div class="products-box">
              <div
                v-for="(product, index) in companyInfo.products"
                :key="index"
                class="mb-3"
              >
                <span class="c-grey fs-medium">
                  <v-icon class="pt-4 c-grey">mdi-circle-medium</v-icon>
                  {{ " " + product.title }}
                </span>
              </div>
            </div>
          </v-container>
        </v-card>
        <v-card v-if="seeMoreType == 'category'" class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xxlarge">
                  موضوع‌‌ فعالیت زیست فناوری
                </h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="seeMoreModal = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div
              v-if="!companyInfo.catName"
              class="py-4 c-grey fs-small text-center"
            >
              موردی برای نمایش وجود ندارد.
            </div>
            <div v-else class="categories-box">
              <div class="mb-3">
                <span class="c-grey fs-medium">
                  <v-icon class="pt-4 c-grey">mdi-circle-medium</v-icon>
                  {{ " " + companyInfo.catName }}
                </span>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editModal" :width="editType != 'logo' ? '600' : '450'">
        <v-card v-if="editType == 'description'" class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xlarge">ویرایش توضیحات شرکت</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="editModal = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div class="description-input">
              <v-textarea
                outlined
                rounded
                no-resize
                :loading="gettingInfo"
                v-model="editInfo.description"
              ></v-textarea>
            </div>
            <div class="mt-3">
              <v-btn
                @click="openConfirmationDialog('description')"
                color="#93329e"
                class="c-light"
                width="100"
                height="42"
                >تایید</v-btn
              >
            </div>
          </v-container>
        </v-card>
        <v-card v-if="editType == 'contact'" class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xlarge">ویرایش راه‌های ارتباطی</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="editModal = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div class="disabled-textField">
              <v-row class="mb-4">
                <v-col>
                  <div class="disabled-fields">
                    <div class="label">استان</div>
                    {{ editInfo.state }}
                  </div>
                </v-col>
                <v-col>
                  <div class="disabled-fields">
                    <div class="label">شهر</div>
                    {{ editInfo.city ? editInfo.city : "-" }}
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="textField-box">
              <v-text-field
                label="نشانی شرکت"
                outlined
                rounded
                :loading="gettingInfo"
                v-model="editInfo.address"
              ></v-text-field>
              <v-text-field
                label="تلفن‌های تماس "
                outlined
                rounded
                :loading="gettingInfo"
                v-model="editInfo.tel"
              ></v-text-field>
              <v-text-field
                label="ایمیل"
                outlined
                rounded
                :loading="gettingInfo"
                v-model="editInfo.email"
              ></v-text-field>
              <div
                v-if="!validateEmail(editInfo.email)"
                class="red--text fs-xsmall mb-4"
                style="margin-top: -20px"
              >
                ایمیل وارد شده صحیح نمی‌باشد.
              </div>
              <v-text-field
                label="آدرس تارنما"
                outlined
                rounded
                :loading="gettingInfo"
                v-model="editInfo.website"
              ></v-text-field>
            </div>
            <div
              v-if="checkUrl(editInfo.website)"
              class="red--text fs-xsmall mb-4"
              style="margin-top: -20px"
            >
              آدرس تارنما وارد شده صحیح نمی‌باشد.
            </div>
            <div class="mt-3">
              <v-btn
                @click="openConfirmationDialog('contact')"
                color="#93329e"
                class="c-light"
                width="100"
                height="42"
                :disabled="
                  !validateEmail(editInfo.email) || !validURL(editInfo.website)
                "
                >تایید</v-btn
              >
            </div>
          </v-container>
        </v-card>
        <v-card v-if="editType == 'products'" class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xlarge">ویرایش محصولات</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="editModal = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div class="edit-box">
              <div
                v-for="(item, index) in editInfo.products"
                :key="index"
                class="textField-box"
              >
                <v-text-field
                  outlined
                  rounded
                  :placeholder="'آیتم ' + (index + 1)"
                  v-model="item.title"
                >
                  <template v-slot:append>
                    <span @click="removeProduct(index)" class="pointer">
                      <v-icon>$Trash</v-icon>
                    </span>
                  </template>
                </v-text-field>
              </div>
              <v-btn @click="addProduct()" class="add-btn w-100" height="48">
                <v-icon class="pt-3" color="#93329e" large>mdi-plus</v-icon>
              </v-btn>
            </div>
            <div class="mt-5">
              <v-btn
                @click="openConfirmationDialog('products')"
                color="#93329e"
                class="c-light"
                width="100"
                height="42"
                :disabled="computedProductsBtn"
                >تایید</v-btn
              >
            </div>
          </v-container>
        </v-card>
        <v-card v-if="editType == 'logo'" class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xlarge">ویرایش لوگو شرکت</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="editModal = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div
              v-if="!uploading"
              class="upload-box"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
            >
              <p class="c-grey fs-large mb-2">
                فایل مورد نظر را به این قسمت بکشید
              </p>
              <p class="c-grey fs-large mb-2">یا</p>
              <v-btn
                @click="$refs.upload.$refs.input.click()"
                class="upload-btn"
                height="42"
                >یافتن فایل</v-btn
              >
            </div>
            <div v-else>
              <div class="d-flex flex-row w-100">
                <div>
                  <v-icon class="mt-2" large>$File</v-icon>
                </div>
                <div class="w-100 px-3">
                  <p class="mb-0">در حال بارگذاری تصویر...</p>
                  <v-progress-linear
                    class="mt-1"
                    outlined
                    height="4"
                    :value="myFile.uploadPercentage"
                    color="#93329e"
                  >
                  </v-progress-linear>
                </div>
                <div class="c-purple pt-4">{{ myFile.uploadPercentage }}%</div>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showBigModal" width="580">
        <v-card class="modal-card">
          <v-container class="p-4">
            <div class="logo-image">
              <img
                :src="
                  companyInfo.avatar
                    ? companyInfo.avatar
                    : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                "
              />
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="noEditModal" width="580">
        <v-card class="modal-card">
          <v-container class="p-4">
            <v-row>
              <v-col class="text-left">
                <span @click="noEditModal = false" class="pointer">
                  <v-icon>$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div
              v-if="editType == 'name'"
              class="text-center fs-large c-dark pb-4"
            >
              نام شرکت قابل ویرایش نمی‌باشد.
            </div>
            <div v-else class="text-center fs-large c-dark pb-4">
              موضوع فعالیت زیست فناوری قابل ویرایش نمی‌باشد.
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-file-input
        @change="myUpload(file)"
        v-model="file"
        ref="upload"
        outlined
        dense
        v-show="false"
      ></v-file-input>
    </div>
    <v-dialog v-model="confirmationDialog" width="700">
      <v-card class="modal-card">
        <v-container class="p-4">
          <h4 class="c-dark">ثبت تغییرات</h4>
          <hr />
          <p class="c-dark mb-2 fs-medium">
            شرکت محترم، آیا از صحت کلیه اطلاعات وارد شده مطمئن هستید؟
          </p>
          <p class="red--text lighten-1">
            <v-icon class="red--text lighten-1" style="margin: 10px -5px 0 0"
              >mdi-alert-circle-outline</v-icon
            >
            تایید این پیام به منزله ثبت اطلاعات و انتشار آنها در وبسایت ستاد
            توسعه زیست فناوری خواهد بود.
          </p>
          <div class="pt-4 d-flex justify-content-center">
            <v-btn
              @click="confirmationDialog = false"
              elevation="0"
              width="130"
              class="btn-border bc-white c-purple mx-2"
              >خیر</v-btn
            >
            <v-btn
              @click="
                editType == 'registrationInfo'
                  ? editRegistrationInfo()
                  : editType == 'description'
                  ? editDescription()
                  : editType == 'products'
                  ? editProducts()
                  : editType == 'contact'
                  ? editContact()
                  : ''
              "
              :loading="isBusy"
              elevation="0"
              width="130"
              class="bc-purple c-light mx-2"
              >بله</v-btn
            >
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
import Chart from "/src/components/charts/Chart.vue";
import validator from "validator";
import isURL from "validator/lib/isURL";

export default {
  components: {
    Chart,
    isURL,
    validator,
  },
  data() {
    return {
      uploadedFiles: [],
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      city: "",
      model: 0,
      interval: {},
      busy: true,
      value: 0,
      companyInfo: {},
      list: [],
      loaded: false,
      pageLoaded: false,
      professorListSize: "",
      type: "",
      isBusy: false,
      vLoading: false,
      seeMoreModal: false,
      seeMoreType: "",
      editModal: false,
      editInfo: {
        products: [],
      },
      editType: "",
      gettingInfo: false,
      showBigModal: false,
      uploading: false,
      editMoreInfo: false,
      moreInfoDialog: false,
      noEditModal: false,
      confirmationDialog: false,
      editType: "",
    };
  },
  methods: {
    openConfirmationDialog(type) {
      this.editType = type;
      this.confirmationDialog = true;
    },
    checkWebsite() {
      if (
        this.companyInfo.website.indexOf("http://") == 0 ||
        this.companyInfo.website.indexOf("https://") == 0
      ) {
        return this.companyInfo.website;
      } else {
        return "//" + this.companyInfo.website;
      }
    },
    checkUrl(url) {
      if (this.editInfo.website) {
        if (validator.isURL(url)) {
          return false;
        } else {
          return true;
        }
      }
    },
    toFindDuplicates(array) {
      const count = {};
      const result = [];

      array.forEach((item) => {
        if (count[item]) {
          count[item] += 1;
          return;
        }
        count[item] = 1;
      });

      for (let prop in count) {
        if (count[prop] >= 2) {
          result.push(prop);
        }
      }
      return result;
    },

    checkDuplicate() {
      let temp = [];
      this.editInfo.products.forEach((x) => {
        temp.push(x.title);
      });
      const duplicateElements = this.toFindDuplicates(temp);
      if (duplicateElements.length) {
        return false;
      } else {
        return true;
      }
    },
    openSeeMoreModal(type) {
      this.seeMoreType = type;
      this.seeMoreModal = true;
    },
    openNoEditDialog(type) {
      this.editType = type;
      this.noEditModal = true;
    },
    openEditModal(type) {
      this.editType = type;
      // this.gettingInfo = true;
      this.update();
      if (type == "logo") {
        this.uploading = false;
        this.uploadedFiles = [];
        this.uploadPercentage = 0;
        this.isUploaded = false;
        this.file = [];
        this.myFile = new Object({
          uploadPercentage: 0,
        });
      }
      this.editInfo = JSON.parse(JSON.stringify(this.companyInfo));
      if (!this.editInfo.products.length) {
        this.editInfo.products = [];
      }
      this.editModal = true;
    },

    addProduct() {
      this.editInfo.products.push({ title: "" });
      setTimeout(() => {
        var container = document.querySelector(".edit-box");
        var scrollHeight = container.scrollHeight;
        container.scrollTop = scrollHeight;
      }, 100);
    },
    removeProduct(index) {
      this.editInfo.products.splice(index, 1);
    },
    goToMap(to) {
      this.$router.push("/map");
    },
    goToImages() {
      this.$router.push("/company/images");
    },
    validateEmail(email) {
      if (email) {
        var re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      } else return true;
    },
    validURL(str) {
      if (str) {
        var pattern = new RegExp(
          "^(https?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
            "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$",
          "i"
        ); // fragment locator
        return !!pattern.test(str);
      } else return true;
    },
    getProfileInfo() {
      if (window.screen.width < 850) {
        this.type = "mobile";
      } else {
        if (document.body.clientWidth < 850) {
          this.type = "mobile";
        } else {
          this.type = "desktop";
        }
      }

      //Function
      this.vLoading = true;
      //!this.gettingInfo ? (this.vLoading = true) : "";
      this.$http
        .post(
          this.baseUrl + "/setad/company/profile/dashboard",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companyInfo = res.data;
          this.vLoading = false;
          this.loaded = true;
          this.gettingInfo = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.gettingInfo = false;
          this.vLoading = false;
        });
    },
    update() {
      if (window.screen.width < 850) {
        this.type = "mobile";
      } else {
        if (document.body.clientWidth < 850) {
          this.type = "mobile";
        } else {
          this.type = "desktop";
        }
      }

      //Function
      //!this.gettingInfo ? (this.vLoading = true) : "";
      this.$http
        .post(
          this.baseUrl + "/setad/company/profile/dashboard",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companyInfo = res.data;
          this.loaded = true;
          this.gettingInfo = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.gettingInfo = false;
        });
    },
    myUpload(file) {
      if (!file) {
        return;
      }

      //CHECK FILE SIZE

      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        // START UPLOAD PROCESS
        this.uploading = true;
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/company/profile/avatar", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.myFile.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((res) => {
            if (res.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.companyInfo.avatar = res.data;
              this.toast("لوگو با موفقیت ویرایش گردید.", "success");
              this.editModal = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles = {};
            this.additionalFiles.contract = {};
            this.myFile.uploadPercentage = 0;
          });
      }
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      //event.preventDefault();
      //this.file = event.dataTransfer.files;
      //this.myUpload(this.file);
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
      event.preventDefault();
      this.file = event.dataTransfer.files;
      if (Array.from(this.file).length) {
        if (Array.from(this.file).length > 1) {
          this.toast(
            " در این بخش شما مجاز به آپلود بیش از یک عکس نمی‌باشید.",
            "error"
          );
          return;
        }
        Array.from(this.file).forEach((file) => {
          this.myUpload(file);
        });
      }
    },
    editDescription() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/company/profile/editDescription",
          {
            description: this.editInfo.description,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          this.editModal = false;
          this.confirmationDialog = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    editContact() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/company/profile/editContactUs",
          {
            address: this.editInfo.address,

            tel: this.editInfo.tel,

            website: this.editInfo.website,

            email: this.editInfo.email,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          this.editModal = false;
          this.confirmationDialog = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          this.vLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    editRegistrationInfo() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/company/profile/editRegistrationInfo",
          {
            registrationNumber: this.editInfo.registrationNumber,
            nationalId: this.editInfo.nationalId,
            economicCode: this.editInfo.economicCode,
            ceoName: this.editInfo.ceoName,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          this.confirmationDialog = false;
          this.toast(res.data, "success");

          this.update();
          this.editMoreInfo = false;
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    editProducts() {
      if (!this.checkDuplicate()) {
        this.toast("امکان ثبت محصول تکراری وجود ندارد", "error");
        return;
      } else {
        this.vLoading = true;
        this.$http
          .post(
            this.baseUrl + "/setad/company/profile/editProducts",
            {
              products: this.editInfo.products,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.vLoading = false;
            this.editModal = false;
            this.confirmationDialog = false;
            this.toast(res.data, "success");
            this.update();
          })
          .catch((err) => {
            this.vLoading = false;
            console.log(err);
            this.toast(err.response.data, "error");
            if (err.response.status == 403)
              // this.$router.replace("/unauthorize");
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          });
      }
    },
  },
  computed: {
    computedProductsBtn() {
      if (this.editInfo.products) {
        let emptyField =
          this.editInfo.products.length ==
          this.editInfo.products.filter((x) => x.title).length;
        if (emptyField) {
          return false;
        } else {
          return true;
        }
      }
    },
    showProductMoreBtn() {
      let temp;
      if (this.companyInfo.products) {
        temp = this.companyInfo.products.filter((x) => x.title.length > 70);
        if (temp.length) {
          return true;
        } else {
          return false;
        }
      }
    },
    showCategoryMoreBtn() {
      let temp;
      if (this.companyInfo.catName) {
        temp = this.companyInfo.catName.length > 70;
        if (temp.length) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  mounted() {
    if (this.$route.fullPath == "/company/dashboard") this.getProfileInfo();
  },
  watch: {
    $route(val, oldVal) {
      if (val.fullPath == "/company/dashboard") this.getProfileInfo();
    },
  },
};
</script>
<style lang="scss">
.info-icon {
  color: #93329e !important;
}
.edit-row {
  justify-content: flex-end;
}
.purple-btn {
  background-color: #93329e !important;
  color: white !important;
  path {
    stroke: #fff;
  }
}
.modal-card {
  border-radius: 10px !important;
  .v-label {
    font-size: 0.9rem !important;
    color: #93329e !important;
    background-color: #fff;
    padding: 1px 10px;
    margin-bottom: 0 !important;
    height: 25px;
    transform: translateY(-31px);
  }
  .products-box,
  .categories-box {
    margin: 5px 0;
    max-height: 450px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: #eee;
      opacity: 0.5;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      width: 10px;
      border-radius: 10px;
    }
  }
  .v-text-field__details {
    display: none !important;
  }
  .description-input {
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #93329e !important;
      padding-bottom: 15px !important;
      .v-text-field__slot {
        textarea {
          color: #656a81 !important;
          padding: 0 15px !important;
          &::-webkit-scrollbar {
            width: 8px;
          }

          &::-webkit-scrollbar-track {
            background-color: #eee;
            opacity: 0.5;
            border-radius: 10px;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #bdbdbd;
            width: 10px;
            border-radius: 10px;
          }
        }
      }
    }
  }
  .disabled-textField {
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #969397 !important;
    }
    .v-input__slot {
      min-height: 48px !important;
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }

    label.v-label,
    label.v-label.v-label--active.theme--light {
      font-size: 0.9rem !important;
      color: #969397 !important;
      background-color: #fff;
      padding: 1px 10px;
      margin-bottom: 0 !important;
      height: 25px;
      transform: translateY(-31px);
    }
  }
  .textField-box {
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #93329e !important;
    }
    .v-input__slot {
      min-height: 48px !important;
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }

    label.v-label.v-label--active.theme--light {
      font-size: 0.9rem !important;
      color: #93329e !important;
      background-color: #fff;
      padding: 1px 10px;
      margin-bottom: 0 !important;
      height: 25px;
      transform: translateY(-31px);
    }
  }
  .edit-box {
    max-height: 400px;
    overflow-y: auto;
    padding: 10px 0;
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: #eee;
      opacity: 0.5;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      width: 10px;
      border-radius: 10px;
    }
  }
  .add-btn {
    border: 1px solid #93329e;
    background-color: rgba(154, 6, 128, 0.07) !important;
    box-shadow: none !important;
    border-radius: 6px !important;
    outline: none !important;
  }
  .v-icon {
    transform: translateY(-6px);
  }
  .upload-box {
    padding: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='9' ry='9' stroke='rgb(147, 50, 158)' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='5' stroke-linecap='butt'/%3e%3c/svg%3e");
    .upload-btn {
      border: 1px solid #93329e;
      background-color: #fff;
      border-radius: 5px;
      font-size: 0.95rem;
      font-weight: bold;
      color: #93329e;
      box-shadow: none !important;
    }
  }
  .logo-image {
    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }
}
.transparent-card {
  background-color: transparent !important;
  box-shadow: none !important;
}

.company-img {
  width: 150px !important;
  height: 95px !important;
  border-radius: 3px;
}
.logo-box {
  width: 100px !important;
  height: 100px !important;
  margin-top: 5px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
}
</style>
